import type { Nullable } from '@ats/interfaces';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { AspectRatio } from '@hooks/ref/useElementAspectRatio';
import type { VideoGridProps } from './';

interface GridContainerProps extends VideoGridProps {
  ratio?: Nullable<AspectRatio>;
  size: number;
  featured: boolean;
  shared?: boolean;
}

export const Container = styled.div<GridContainerProps>(({ size, shared }) => {
  const rows = size > 5 ? 3 : Math.ceil(size / 2);
  // `oxfmt` mangles `calc()` when it contains an interpolation
  // (`calc (` / `% -4px`), which silently produces invalid CSS.
  // Build the value outside the css`` template so it is left alone.
  const rowHeight = `calc(${100 / rows}% - 4px)`;
  if (shared)
    return css`
      margin: auto;
      display: flex;
      gap: 8px;
      & > * {
        margin: 0;
        width: 240px;
        height: 180px;
      }

      @media screen and (min-width: 1440px) {
        & > * {
          width: 280px;
          height: 210px;
        }
      }
      @media screen and (min-width: 1920px) {
        & > * {
          width: 320px;
          height: 240px;
        }
      }
    `;
  return css`
    gap: 8px;
    display: grid;
    grid-template-rows: repeat(${rows}, ${rowHeight});
    grid-template-columns: 1fr 1fr;
    max-height: 100%;
    height: ${size === 2 ? 'fit-content' : '100%'};
    width: 100%;
    & > *:nth-of-type(2n) {
      justify-content: start;
      width: 100%;
    }
    & > *:nth-of-type(2n-1) {
      justify-content: end;
      width: 100%;
    }
    & > *:nth-of-type(2n-1):nth-last-of-type(1) {
      grid-column: span 2;
      justify-content: center;
    }
    & video {
      aspect-ratio: 4/3;
    }
  `;
});
